import script from "./requestView.vue?vue&type=script&setup=true&lang=js"
export * from "./requestView.vue?vue&type=script&setup=true&lang=js"

import "./requestView.vue?vue&type=style&index=0&id=774fa3c5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774fa3c5"]])

export default __exports__